import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react'
import services from '../../ioc/services';
import { MultiSelectDropdown } from '../components';

function AgentsDropdown({ valueUpdater, defaultValue = [] }) {

  const [agents, setAgents] = useState([]);

  const [defaultSelected, setDefaultSelected] = useState([]);


  useEffect(() => {

    services.api.agent.getAgents()
      .then(res => {
        setAgents(res.map(a => ({
          "value": a._id,
          "key": `${a.firstName} ${a.lastName}`
        })))

        setDefaultSelected(
          res.filter(a => defaultValue.includes(a._id))
            .map(a => ({
              "value": a._id,
              "key": `${a.firstName} ${a.lastName}`
            })))

      })

  }, [defaultValue])

  return (

    <div className='flex-1'>

      <MultiSelectDropdown defaultValue={defaultSelected} options={agents} placeholder="Select Agents" valueUpdater={valueUpdater} />
    </div>


  )
}

export default AgentsDropdown